<template>
  <NavBar />
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="card rounded-3 border-0">
          <div class="card-body">
            
              <div class="row">
                <div class="col-12 pb-5 pt-5">
                  <div v-if="HasQueryData && Status" class="text-center">
                    <p class="fs-1"><i class="bi bi-check2-circle text-success"></i></p>
                    <p class="fs-4">Ödeme işlemi başarılı.<br /><span class="fw-normal">Sizinle en kısa sürede iletişime geçilecektir.</span></p>
                  </div>
                  <div v-else-if="HasQueryData && !Status" class="text-center">
                    <p class="fs-1"><i class="bi bi-x-circle text-danger"></i></p>
                    <p class="fs-4">Ödeme işlemi başarısız!<br /><span v-if="Message!=''" class="fs-5">( {{ Message }} )</span></p>
                    <span v-if="ReturnUrlForFailPay!=''">Tekrar denemek için <a v-bind:href="ReturnUrlForFailPay">tıklayınız.</a></span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterInPage />
</template>
<script>
import {GetCookie} from "@/common/cookie-helper";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
export default {
  name: 'MarketCheckoutResultPage',
  data() {
    return {
        
    };
  },
  components: {
    NavBar,
    FooterInPage,
  },
  computed:{
    HasQueryData(){
      if(this.$route.query.status){
        return true;
      }
      return false;
    },
    Status(){
      let status = this.$route.query.status;
      if(status==='fail'){
        return false;
      }else if(status==='ok'){
        return true;
      }else{
        return false;
      }
    },
    Message(){
      let message = this.$route.query.message;
      if(message){
        return message;
      }
      return '';
    },
    ReturnUrlForFailPay(){
      var cookie = GetCookie('ReturnUrlForFailPayment');
      if(cookie)
      {
        return cookie;
      }

      return '';
    }
  },
  methods: {
  },
  mounted: function() {
    if(!this.$route.query.status){
      this.$router.push({path:"/market",name:"Market"});
    }
    // var status    = this.$route.query.status;
    // var orderid   = this.$route.query.orderid;
    // var amount    = this.$route.query.amount;
    // var authCode  = this.$route.query.authCode;
    // var message   = this.$route.query.message;
    // var packageId = this.$route.query.packageId;
  }
}
</script>
<style>
 
</style>